import React from 'react'

export default function About() {
  return (
    <div>
      <section id="about" className="about">
      <div className="container">

        <div className="row">
          <div className="col-lg-6 order-1 order-lg-2" data-aos="fade-left">
            <img src="assets/img/aboutpic.png" className="img-fluid" alt="" />
          </div>
          <div className="col-lg-6 pt-4 pt-lg-0 order-2 order-lg-1 content" data-aos="fade-right">
            <h3>Welcome to our Insurance Services,where protection meets peace of mind.</h3>
            <p className="fst-italic">
              At our core we priortize safeguarding what matters most to you by offering comprehensive insurance coverage.
            </p>
            <ul>
              <li><i className="bi bi-check-circle"></i> "Drive assured with our comprehensive Car Insurance-your protection on road in our guarantee"</li>
              <li><i className="bi bi-check-circle"></i> "Secure your well-being with our comprehensive Health Insurance coverage"</li>
              <li><i className="bi bi-check-circle"></i> "Embark on worry-free journeys with our comprehensive Travel Insurance"</li>
              <li><i className="bi bi-check-circle"></i> "Ensure your family's financial security with our tailored Life Insurance plans"</li>
              <li><i className="bi bi-check-circle"></i> "Enhance your vehicle's safety with our state-of-the-art Car Tracker services."</li>


            </ul>
            <p>
             Discover your peace of mind with our tailored insurance solutions.Safeguard what matters most to you.Trust us to guide through life's uncertainities.Choose reliablity and assurance for a secure future.
            </p>
          </div>
        </div>

      </div>
    </section>
    </div>
  )
}
